import React from "react";

const defaultTestimonials = [
  {
    image: "/images/testimonial-passport.jpg",
    name: "Abdul Jaji",
    quote:
      "Our tour guide was absolutely fantastic! Very knowledgeable, friendly, and patient throughout the entire trip. They explained the history and culture in a way that was easy to understand and kept the group engaged.",
  },
  {
    image: "/images/testimonial-passport.jpg",
    name: "Emilia A.",
    quote:
      "They explained the history and culture in a way that was easy to understand and kept the group engaged. They explained the history and culture in a way that was easy to understand and kept the group engaged.",
  },
  {
    image: "/images/testimonial-passport.jpg",
    name: "Jake T.",
    quote:
      "Booking both rides and stays in one place saved so much time. I felt supported the whole journey. They explained the history and culture in a way that was easy to understand and kept the group engaged.",
  },
  {
    image: "/images/testimonial-passport.jpg",
    name: "Jake T.",
    quote:
      "Booking both rides and stays in one place saved so much time. I felt supported the whole journey. They explained the history and culture in a way that was easy to understand and kept the group engaged.",
  },
];

function Testimonials({
  title = "Testimonials",
  testimonials = defaultTestimonials,
  className = "",
}) {
  return (
    <section className={`sm:max-w-[81vw] w-[90vw] mx-auto sm:px-4 ${className}`}>
      <div className="text-center mb-6 md:mb-12">
        <h2 className="text-2xl font-semibold text-[#570033]">{title}</h2>
      </div>
      <div className="grid md:gap-8 gap-4 grid-cols-2">
        {testimonials.map(({ name, quote, image }, index) => (
          <div
            key={`${name}-${index}`}
            className="max-md:shadow-lg rounded-2xl bg-white lg:p-6 p-3 border-2 border-[#E4E5E670] text-center flex flex-col items-center gap-2 md:gap-4"
          >
            <div className="w-14 h-14">
              <img
                src={image}
                alt={name}
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <h3 className="font-bold text-lg text-[#61013B]/80">{name}</h3>
            <p className="md:text-[13px] text-[12px] leading-5 text-[#2B333C]/80 font-medium">
              {quote}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
